import { ProductInterface } from '../Model/Product';

export enum FilterType {
    Equals = 'equals', // Dropdown
    Contains = 'contains', // Checkbox
    OneOf = 'oneOf', // Checkbox
    Range = 'range',
    Callback = 'callback',
}

export interface FilterInterface<T> {
    type: FilterType;
    /**
     * The current value to test against
     *
     * The Filter will allow a Product if it [`matches`] this value
     * @see matches()
     */
    value: T;
    /**
     * The key-path to the property of the Product that should be compared with `value`
     */
    keyPath: string;
    isActive: boolean;

    /**
     * Return if the Product matches the Filter's value
     *
     * @param {ProductInterface} product
     * @return {boolean}
     */
    matches(product: ProductInterface): boolean;

    /**
     * Return a new copy of the Filter with the given `value` set
     *
     * @param {*} value
     * @return {FilterInterface<*>}
     */
    withValue(value: T): FilterInterface<T>;

    /**
     * Return a new copy of the Filter with the given active flag
     *
     * @param {boolean} isActive
     * @return {FilterInterface<*>}
     */
    withActive(isActive: boolean): FilterInterface<T>;

    /**
     * Return a new copy of the Filter with a cleared value
     *
     * @return {FilterInterface<*>}
     */
    cleared(): FilterInterface<T>;
}
